import Button from "../../../components/ui/Button";
import Select, { type SelectOption } from "../../../components/ui/Select";

interface AnnouncementFiltersProps {
	onFiltersChange: (filters: any) => void;
	onClearFilters: () => void;
	filters: {
		status: string;
		priority: string;
	};
}

const STATUS_OPTIONS: SelectOption[] = [
	{ value: "", label: "All Status" },
	{ value: "draft", label: "Draft" },
	{ value: "active", label: "Active" },
	{ value: "archived", label: "Archived" },
];

const PRIORITY_OPTIONS: SelectOption[] = [
	{ value: "", label: "All Priorities" },
	{ value: "info", label: "Info" },
	{ value: "warning", label: "Warning" },
	{ value: "success", label: "Success" },
	{ value: "urgent", label: "Urgent" },
];

const AnnouncementFilters: React.FC<AnnouncementFiltersProps> = ({
	onFiltersChange,
	onClearFilters,
	filters,
}) => {
	const hasActiveFilters =
		filters.status !== "" || filters.priority !== "";

	return (
		<div className="bg-card border border-border rounded-lg p-4 mb-6">
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				<Select
					label="Status"
					options={STATUS_OPTIONS}
					value={filters.status}
					onValueChange={(value) =>
						onFiltersChange({ ...filters, status: String(value) })
					}
				/>

				<Select
					label="Priority"
					options={PRIORITY_OPTIONS}
					value={filters.priority}
					onValueChange={(value) =>
						onFiltersChange({ ...filters, priority: String(value) })
					}
				/>

				<div className="flex items-end">
					{hasActiveFilters && (
						<Button
							variant="outline"
							onClick={onClearFilters}
							className="w-full"
						>
							Clear Filters
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default AnnouncementFilters;
